import { AutoStopControl } from "appworks/ui/controls/standard/button/auto-stop-control";

export class AgsAutoStopControl extends AutoStopControl {
    public setEnabled(enabled: boolean): void {
        // Never disable the autoplay stop button
        super.setEnabled(true);
    }
}
